import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useUserAchievements } from '@/hooks/useAchievements';
import { AchievementNotification } from './AchievementNotification';
import { createPortal } from 'react-dom';

/**
 * Global component that listens for new achievement unlocks
 * and displays celebration notifications
 */
export function AchievementNotificationDisplay() {
  const { user } = useAuth();
  const { notification, clearNotification } = useUserAchievements(user?.id);

  if (!notification) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 pointer-events-none">
      <div className="pointer-events-auto">
        <AchievementNotification
          achievement={notification.achievement}
          xpGained={notification.xp}
          onClose={clearNotification}
        />
      </div>
    </div>,
    document.body
  );
}
